import type { LocalePack } from './types.js';

/** Danish */
export const da: LocalePack = {
  headerTitle: 'Fotoredigering',
  headerSubtitle: 'Rediger dit billede med lethed',
  applyButton: 'Anvend',
  cancelButton: 'Luk',
  undo: 'Fortryd',
  redo: 'Gentag',
  fullscreen: 'Fuld skærm',
  fit: 'Tilpas',
  zoomTooltip: 'Zoom · +/− · 0 tilpas · 1 100%',

  emptyStateTitle: 'Slip et billede eller klik for at uploade',
  emptyStateSubtitle: 'Understøttet: PNG, JPEG, HEIC',

  calloutLabelText: 'Etiket',

  tool: {
    select: 'Vælg',
    crop: 'Beskær',
    draw: 'Tegn',
    eraser: 'Viskelæder',
    text: 'Tekst',
    shapes: 'Former',
    callout: 'Note',
    filters: 'Filtre',
    adjust: 'Juster',
    move: 'Flyt',
    pen: 'Pen',
    zoom: 'Zoom',
    zoomIn: 'Zoom ind',
    zoomOut: 'Zoom ud',
    rotateLeft: 'Roter venstre',
    rotateRight: 'Roter højre',
    flipH: 'Vend V',
    flipV: 'Vend L',
    reset: 'Nulstil',
  },

  shape: {
    circle: 'Cirkel',
    ellipse: 'Ellipse',
    square: 'Kvadrat',
    rectangle: 'Rektangel',
    arrow: 'Pil',
    polyline: 'Linjesti',
  },

  filter: {
    none: 'Original',
    grayscale: 'S/H',
    sepia: 'Sepia',
    vintage: 'Vintage',
    cool: 'Kølig',
    warm: 'Varm',
    invert: 'Inverter',
  },

  props: {
    title: {
      draw: 'Tegn',
      eraser: 'Viskelæder',
      text: 'Tekst',
      crop: 'Beskær',
      shapes: 'Former',
      callout: 'Note',
      filters: 'Filtre',
      adjust: 'Juster',
      move: 'Flyt',
    },
    aspectRatio: 'Højde-bredde-forhold',
    applyCrop: 'Anvend beskæring',
    cancel: 'Annuller',
    shape: 'Form',
    preset: 'Forudindstilling',
    resetEffects: 'Nulstil effekter',
    resetAdjustments: 'Nulstil justeringer',
    deleteSelected: 'Slet valgte',
    colors: 'Farver',
    recent: 'Seneste',
    customColor: 'Brugerdefineret farve',
    brushSize: 'Penselstørrelse',
    strokeWidth: 'Streg­bredde',
    opacity: 'Uigennemsigtighed',
    eraserSize: 'Viskelæderstørrelse',
    fontSize: 'Skriftstørrelse',
    brightness: 'Lysstyrke',
    contrast: 'Kontrast',
    saturation: 'Mætning',
    blur: 'Sløring',
    quickActions: 'Hurtige handlinger',
    hintMove:
      'Træk for at panorere · knib eller rul for at zoome · vælg et værktøj for at begynde.',
    hintEraser: 'Tryk eller træk på en annotation for at fjerne den.',
  },
};
